import { useState } from 'react'
import s from './Contacts.scss'
import { Table } from 'reactstrap'
import { Checkbox } from 'components/ideal-core-ui'
import Select from 'react-select'
import { APP_CONSTANTS } from 'utils/constants'
import { FaRegEnvelope } from 'react-icons/fa'
import {
  fromConstantPropertyToSelectOptions,
  fromConstantPropertyToSelectValue
} from 'utils/serializers'
import { EmailContactModalContainer } from 'components/common/modals/EmailContactModalContainer'

const Contacts = ({
  contacts,
  changeContactIsMain,
  withRoles,
  changeClientContactRole,
  withEmailContact,
  entity,
  clientId,
  withSaveEmailAsNote
}) => {
  const [showEmailContactModal, setShowEmailContactModal] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)

  const toggleEmailContactModal = () => setShowEmailContactModal(prev => !prev)

  const sendEmail = contact => {
    setShowEmailContactModal(true)
    setSelectedContact(contact)
  }

  return (
    <>
      <Table size="sm" className={s.table}>
        <thead className={s.head}>
          <tr>
            <th>Contact Name</th>
            <th>Contact Phone</th>
            <th>Contact Email</th>
            {withRoles && <th>Role for this Opportunity</th>}
            <th>Main Contact</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact, index) => (
            <tr key={contact.value}>
              <td>
                {withEmailContact && (
                  <FaRegEnvelope
                    className={s.sendMailBtn}
                    onClick={() => sendEmail(contact)}
                    title="Sent Email"
                  />
                )}
                <a target="_blank" rel="noreferrer" href={`/contacts/${contact.value}`}>
                  {contact.label}
                </a>
              </td>
              <td>{contact.phone}</td>
              <td>{contact.email}</td>
              {withRoles && (
                <td>
                  <Select
                    onChange={value => changeClientContactRole(value, clientId, index)}
                    value={
                      contact.role
                        ? fromConstantPropertyToSelectValue(contact.role, 'DealClientRole')
                        : ''
                    }
                    options={fromConstantPropertyToSelectOptions(
                      Object.keys(APP_CONSTANTS.DealClientRole),
                      'DealClientRole'
                    )}
                  />
                </td>
              )}
              <td className={s.checkbox}>
                <Checkbox
                  isChecked={contact.isMain}
                  triggerCheckbox={value =>
                    changeContactIsMain(value.target.checked, clientId, index)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showEmailContactModal && (
        <EmailContactModalContainer
          toggleEmailContactModal={toggleEmailContactModal}
          showEmailContactModal={showEmailContactModal}
          contact={selectedContact}
          emailSubject={entity?.name}
          entityId={entity?.id}
          withSaveEmailAsNote={withSaveEmailAsNote}
        />
      )}
    </>
  )
}

export default Contacts
